import { translate as t } from '@thoughtspot/i18n';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Icon, IconColor, IconID, IconSize, } from '@thoughtspot/radiant-react/widgets/icon';
import { CellType } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/cell-type-service';
import { EmptyCell } from '@thoughtspot/radiant-react/widgets/table/table-list-view/cell/empty-cell/empty-cell';
import React from 'react';
import { getIconURL } from "../../../services/system/system-service";
import { ActionButtons, LearnMore } from '../../system/common/constants';
import { DefaultIconMapping, TranslationKeys, } from './constants';
import styles from './help-customization.module.scss';
export const headerConfig = () => [
    {
        title: t(TranslationKeys.HELP_CUSTOMIZATION_TITLE),
        subTitle: t(TranslationKeys.HELP_CUSTOMIZATION_LEARNMORE),
        learnMoreKey: LearnMore.HELP_CUSTOMIZATION,
        isFullWidth: true,
    },
];
export const contentConfig = () => [
    {
        actions: [
            {
                type: ActionButtons.ADD,
                title: t(TranslationKeys.HELP_CUSTOMIZATION_ADD_MENUITEM),
            },
        ],
        title: t(TranslationKeys.HELP_CUSTOMIZATION_SUBTITLE),
        buttonType: 'primary',
        formFields: [],
    },
];
export const tableListViewColumns = () => [
    {
        cellRenderer: CellType[CellType.text],
        headerName: t(TranslationKeys.HELP_CUSTOMIZATION_MENUITEMLABEL),
        colId: 'menuItemName',
        minWidth: 150,
        maxWidth: 220,
    },
    {
        cellRendererFramework: (params) => (React.createElement(EmptyCell, { ...params }, (param) => (React.createElement("div", { className: styles.tableIcon }, DefaultIconMapping[param.iconPath] ? (React.createElement(Icon, { id: DefaultIconMapping[param.iconPath], className: styles.imgWrapper, size: IconSize.LARGE, color: IconColor.GRAY })) : (React.createElement("img", { src: param.iconPath, className: styles.imgWrapper, alt: "custom_icon" })))))),
        headerName: t(TranslationKeys.HELP_CUSTOMIZATION_CUSTOMICON),
        colId: 'menuItemIcon',
        minWidth: 95,
        maxWidth: 140,
    },
    {
        cellRenderer: CellType[CellType.link],
        headerName: t(TranslationKeys.HELP_CUSTOMIZATION_ITEMURL),
        colId: 'menuItemURL',
        flex: 2,
    },
    {
        cellRenderer: CellType[CellType.text],
        headerName: t(TranslationKeys.HELP_CUSTOMIZATION_STATUS),
        colId: 'menuItemStatus',
        minWidth: 85,
        maxWidth: 100,
    },
    {
        cellRendererFramework: (params) => (React.createElement(EmptyCell, { ...params }, (cellValues) => (React.createElement("div", { className: styles.editButtonContainer },
            React.createElement(Button, { id: "edit", text: t(TranslationKeys.HELP_CUSTOMIZATION_EDIT), type: "secondary", backgroundType: "light", onClick: cellValues.onClick, "data-testid": "editItem" }))))),
        colId: 'menuItemEditAction',
        flex: 1,
    },
];
export const flattenObject = (currentFormData, currentConfigId) => {
    const obj = {
        id: currentConfigId,
        enabled: true,
        title: '',
        url: '',
        fileName: '',
        iconBase64String: '',
    };
    currentFormData.forEach(({ id, value, file, iconBase64String }) => {
        switch (id) {
            case 'mount_item_label':
                obj.title = value;
                break;
            case 'item_url':
                obj.url = value;
                break;
            case 'mount_item_icon':
                obj.fileName = file?.name || '';
                obj.iconBase64String = iconBase64String || '';
                break;
            case 'itemStatus':
                obj.enabled = value.toString() === 'true';
                break;
            default:
        }
    });
    return obj;
};
export const ImagePreview = ({ onAction, src }) => (React.createElement("div", { className: styles.iconPreviewContainer },
    React.createElement("div", { className: styles.iconCloseContainer },
        React.createElement(Button, { icon: IconID.CROSS_CIRCLE, type: "tertiary", onClick: onAction, className: styles.closeIcon })),
    React.createElement("div", { className: styles.iconPreviewer, id: "iconPreviewDiv" }, DefaultIconMapping[src] ? (React.createElement(Icon, { id: DefaultIconMapping[src], size: IconSize.LARGE, color: IconColor.GRAY, className: styles.enhancedIcon })) : (React.createElement("img", { alt: "custom_icon", src: src })))));
export const convertBlobToBase64 = (blob) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise((resolve, reject) => {
        reader.onloadend = () => {
            const base64String = reader.result || '';
            const trimmedBase64String = base64String.split('base64,')[1];
            resolve([trimmedBase64String, base64String]);
        };
        reader.onerror = () => {
            reject(reader.error);
            reader.abort();
        };
    });
};
export const getCustomIcon = (iconFilePath, id) => {
    if (iconFilePath === 'note') {
        return iconFilePath;
    }
    if (iconFilePath === '' &&
        DefaultIconMapping[id]) {
        return id;
    }
    return getIconURL(iconFilePath);
};
//# sourceMappingURL=config.container.js.map